import React, {useState} from "react"
import MainHeader from "../../mainComponents/Header";
import MainFooter from "mainComponents/MainFooter";
import {Heading} from "../../components";
import {useTranslation} from "react-i18next";
import MainHeaderWithBurger from "../../components/HeaderButton/headerWithBurgerMain";

export default function ProjectsPage() {
    const {t} = useTranslation();

    const tabs = [
        {
            id: 'agro',
            title: t("projects.tabs.1.tabsName"),
            tabsTitle: t("projects.tabs.1.tabsContent.title"),
            content: () =>
                <>
                    <img
                        src={"/images/caseImage.png"}
                        alt={"Page Logo"}
                        className={"object-cover w-full h-[368px] rounded-[24px]"}/>
                    <div className={`gap-2 my-5`}>
                        <Heading
                            size={"desktop_body_l_bold"}
                            className={`text-[#191C30E5]`}>
                            {t("projects.tabs.1.tabsContent.problem")}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5]`}>
                            {t("projects.tabs.1.tabsContent.problemDescription")}
                        </Heading>
                        <Heading
                            size={"desktop_body_l_bold"}
                            className={`text-[#191C30E5] mt-5`}>
                            {t("projects.tabs.1.tabsContent.result")}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5]`}>
                            {t("projects.tabs.1.tabsContent.resultDescription")}
                        </Heading>
                    </div>
                    <div className={`grid lg:grid-rows-1 lg:grid-cols-3 lg:gap-5 grid-cols-2 grid-rows-2`}>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A]`}>
                                01
                            </Heading>
                            <Heading
                                className={`text-[#FFFFFF] text-[20px] leading-[24px] md:uppercase lg:uppercase sm:text-[17px] sm:leading-7 sm:font-medium`}>
                                {t("projects.tabs.1.tabsContent.resultNumber.1")}
                            </Heading>
                        </div>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A] `}>
                                02
                            </Heading>
                            <Heading
                                className={`text-[#FFFFFF] text-[20px] leading-[24px] md:uppercase lg:uppercase sm:text-[17px] sm:leading-7 sm:font-medium`}>
                                {t("projects.tabs.1.tabsContent.resultNumber.2")}
                            </Heading>
                        </div>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A]`}>
                                03
                            </Heading>
                            <Heading
                                className={`text-[#FFFFFF] text-[20px] leading-[24px] md:uppercase lg:uppercase sm:text-[17px] sm:leading-7 sm:font-medium`}>
                                {t("projects.tabs.1.tabsContent.resultNumber.3")}
                            </Heading>
                        </div>
                    </div>
                </>
        },
        {
            id: 'rehab',
            title: t("projects.tabs.2.tabsName"),
            tabsTitle: t("projects.tabs.2.tabsContent.title"),
            content: () =>
                <>
                    <img
                        src={"/images/products_2.png"}
                        alt={"Page Logo"}
                        className={"object-cover w-full h-[368px] rounded-[24px]"}/>
                    <div className={`gap-2 my-5`}>
                        <Heading
                            size={"desktop_body_l_bold"}
                            className={`text-[#191C30E5]`}>
                            {t("projects.tabs.2.tabsContent.problem")}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5]`}>
                            {t("projects.tabs.2.tabsContent.problemDescription")}
                        </Heading>
                        <Heading
                            size={"desktop_body_l_bold"}
                            className={`text-[#191C30E5] mt-5`}>
                            {t("projects.tabs.2.tabsContent.result")}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className={`text-[#191C30E5]`}>
                            {t("projects.tabs.2.tabsContent.resultDescription")}
                        </Heading>
                    </div>
                    <div className={`grid lg:grid-rows-1 lg:grid-cols-3 lg:gap-5 grid-cols-2 grid-rows-2`}>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A]`}>
                                01
                            </Heading>
                            <Heading
                                className={`text-[#FFFFFF] text-[20px] leading-[24px] md:uppercase lg:uppercase sm:text-[17px] sm:leading-7 sm:font-medium`}>
                                {t("projects.tabs.2.tabsContent.resultNumber.1")}
                            </Heading>
                        </div>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A] `}>
                                02
                            </Heading>
                            <Heading
                                className={`text-[#FFFFFF] text-[20px] leading-[24px] md:uppercase lg:uppercase sm:text-[17px] sm:leading-7 font-medium`}>
                                {t("projects.tabs.2.tabsContent.resultNumber.2")}   
                            </Heading>
                        </div>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A]`}>
                                03
                            </Heading>
                            <Heading
                                className={`text-[#FFFFFF] text-[20px] leading-[24px] md:uppercase lg:uppercase sm:text-[17px] sm:leading-7 sm:font-medium`}>
                                {t("projects.tabs.2.tabsContent.resultNumber.3")}          
                            </Heading>
                        </div>
                    </div>
                </>
        },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const renderContent = () => {
        const tab = tabs.find(tab => tab.id === activeTab);
        return tab ? tab.content : null;
    };

    return (
        <div className={"bg-[#B0B0B0] min-h-screen  flex flex-col"}>
            <div className="md:hidden sm:hidden">
                <MainHeader/>
            </div>
            <div className="lg:hidden">
                <MainHeaderWithBurger/>
            </div>

            <div
                className={"lg:pb-[160px] md:pb-[100px] sm:pb-[80px] lg:pt-[100px] md:pt-[50px] sm:pt-[80px] lg:px-6 md:px-5 sm:px-4 container-xs"}>

                <div className="flex flex-row md:flex-col sm:flex-col justify-between gap-5 md:gap-[30px] sm:gap-8">

                    {/* Левая часть с табами */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading size={"desktop_heading_2"} className="text-[#191C30E5] whitespace-pre-wrap  sm:text-[28px] sm:leading-[120%] sm:uppercase">
                            {t("projects.rightTitle")}
                        </Heading>
                        <ul className="mt-10 sm:mt-5 md:flex md:flex-wrap md:gap-2 sm:flex sm:flex-wrap sm:gap-1.5">
                            {tabs.map(tab => (
                                <li key={tab.id}
                                    className={" md:max-w-none sm:max-w-none"}>
                                    <button
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`text-left text-[15px] leading-6 px-3 py-[10px] rounded-md transition-colors duration-200 outline-none ${
                                            activeTab === tab.id
                                                ? "bg-white shadow text-black border border-[#FFB800]"
                                                : "text-gray-700 hover:bg-gray-200 border border-transparent"
                                        }`}
                                    >
                                        {tab.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Правая часть с контентом */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading
                            size={"desktop_heading_5"}
                            className="text-[#191C30E5] uppercase whitespace-pre-line">
                            {tabs.find(tab => tab.id === activeTab)?.tabsTitle}
                        </Heading>
                        <div className="mt-5">
                            {tabs.find(tab => tab.id === activeTab)?.content()}
                        </div>
                    </div>

                </div>

            </div>

            <div className={'mb-0 mt-auto'}>
                <MainFooter/>
            </div>
        </div>

    );
}